import { Address } from './dtos/Station.schema.d'
import { User } from './dtos/User.schema.d'
import axios from 'axios'
import { UserSummary } from './dtos/Manager.schema'

export const getUsers = async (): Promise<UserSummary[]> => {
  const result = await axios.get<UserSummary[]>('/users')
  return result.data
}

export const getUser = async (userId: string): Promise<User> => {
  const result = await axios.get<User>(`/users/${userId}`)
  return result.data
}

export const getLocalUser = async (): Promise<User> => {
  const result = await axios.get<User>('/users/self')
  return result.data
}

export const updateUser = async (
  userId: string,
  userData: User
): Promise<void> => {
  const res = await axios.put<void>(`/users/${userId}`, userData)

  console.log(res.status)
}

export const deleteUser = async (userId: string): Promise<void> => {
  const res = await axios.delete<void>(`/users/${userId}`)

  console.log(res.status)
}

export const updateUserFirstName = async (
  userId: string,
  name: string
): Promise<void> => {
  const res = await axios.put<void>(`/users/${userId}/first-name`, name, {
    headers: { 'Content-Type': 'application/json' }
  })
  console.log(res.status)
}

export const updateUserLastName = async (
  userId: string,
  name: string
): Promise<void> => {
  const res = await axios.put<void>(`/users/${userId}/last-name`, name, {
    headers: { 'Content-Type': 'application/json' }
  })
  console.log(res.status)
}

export const updateUserPhone = async (
  userId: string,
  phone: string | null
): Promise<void> => {
  const res = await axios.put<void>(`/users/${userId}/phone`, phone, {
    headers: { 'Content-Type': 'application/json' }
  })
  console.log(res.status)
}

export const updateUserLandlinePhone = async (
  userId: string,
  phone: string | null
): Promise<void> => {
  const res = await axios.put<void>(`/users/${userId}/landline-phone`, phone, {
    headers: { 'Content-Type': 'application/json' }
  })
  console.log(res.status)
}

export const updateUserEmail = async (
  userId: string,
  email: string
): Promise<void> => {
  const res = await axios.put<void>(`/users/${userId}/email`, email, {
    headers: { 'Content-Type': 'application/json' }
  })

  console.log(res.status)
}

export const updateUserAddress = async (
  userId: string,
  address: Address | null
): Promise<void> => {
  const res = await axios.put<void>(`/users/${userId}/address`, address)
  console.log(res.status)
}

export const startPasswordReset = async (email: string): Promise<void> => {
  const res = await axios.post<void>(
    '/users/reset-password',
    { email: email },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  )

  console.log(res.status)
}

export const setUserPassword = async (
  userId: string,
  password: string
): Promise<void> => {
  const res = await axios.put<void>(`/users/${userId}/password`, password, {
    headers: { 'Content-Type': 'application/json' }
  })
  console.log(res.status)
}

export const completePasswordReset = async (
  userId: string,
  password: string,
  token: string
): Promise<void> => {
  const res = await axios.post<void>(
    `/users/${userId}/password/${token}`,
    { password: password },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  )
  console.log(res.status)
}

export const updateIsUserBanned = async (
  userId: string,
  isBanned: boolean
): Promise<void> => {
  const res = await axios.put<void>(`/users/${userId}/is-banned`, isBanned, {
    headers: { 'Content-Type': 'application/json' }
  })
  console.log(res.status)
}

export const updateIsUserAdmin = async (
  userId: string,
  isAdmin: boolean
): Promise<void> => {
  const res = await axios.put<void>(`/users/${userId}/is-admin`, isAdmin, {
    headers: { 'Content-Type': 'application/json' }
  })
  console.log(res.status)
}

export const userExists = async (email: string): Promise<boolean> => {
  const result = await axios.post<boolean>(
    '/users/exists/email',
    { email: email },
    { params: { email } }
  )
  return Boolean(result.data)
}
